import { MapTo } from '@adobe/aem-react-editable-components';
import PageSection, { PageSectionEditConfig } from './PageSection';

export default MapTo('cob-corp-acquisition/components/creditonebank/page-section')(PageSection, PageSectionEditConfig);